import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

let authorized = false;
let error, storeHash;

// Read JWT from query parameter
const urlParams = new URLSearchParams(window.location.search);
const jwtFromQuery = urlParams.get('jwt');
// Store JWT in localStorage if present
if (jwtFromQuery) {
    localStorage.setItem('jwt', jwtFromQuery);
    // Remove query parameter from URL for cleaner UX
    window.history.replaceState({}, document.title, '/');
}
// Get JWT from localStorage
const jwt = localStorage.getItem('jwt');

if (process.env.REACT_APP_STORE_HASH) {
    // Make this App accessible by a specific BigCommerce store when REACT_APP_STORE_HASH env is present
    authorized = true;
    storeHash = process.env.REACT_APP_STORE_HASH;
    localStorage.setItem('store_hash', storeHash);
} else if (!jwt) {
    authorized = false;
    error = 'Not Authorized';
} else {
    // Make this App accessible by only the BigCommerce stores who purchases it
    try {
        const response = await fetch('/api/store-info', {
            headers: {Authorization: `Bearer ${localStorage.getItem('jwt')}`},
        });
        const data = await response.json();
        authorized = response.ok;
        if (!authorized)
            error = data.error;
        else {
            storeHash = data.store_hash;
            localStorage.setItem('store_hash', storeHash);
        }
    } catch (e) {
        error = `Failed to load store data: ${e.message}`;
    }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App authorized={authorized}
             error={error}
             storeHash={storeHash}
        />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
